<template>
    <div :style="{'height' : domHeight +'px' }">
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>
        <swb-result-table class="mt10" name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $, EventBus } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import appConf from '../../app.conf';
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import accStockApi from '../../api/accStock'

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    export default {
        name: 'swb-specific-acc-rec-list',
        desc: '个体化配件记录',// 用于 PC查询门店设备服务子号
        authen: false,
        avlActions: '',
        avlScopes: 'retailer',
        props: {
            accId: {
                type: Number,
                default: 'null'
            },
            boundDevcId: {
                type: Number,
                default: 'null'
            },
            vendorSn: {
                type: String,
                default: null
            },
        },
        data: function () {
            return {
                confKey: "swb-specific-acc-rec-list",
                queryOnLoad: true,
                tableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //排序、搜索
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            this.getSpecificAccRecList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onQueryConfigReady: function () {
                let self = this;
                // 锁定业务类型
                let accVoucherTypeList = getEnumList("accVoucherType");
                let voucherTypeList = [];
                voucherTypeList.push({
                    value: null,
                    label: '- 全部 -'
                });
                if(accVoucherTypeList != null && accVoucherTypeList.length > 0) {
                    accVoucherTypeList.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        voucherTypeList.push(queryItem);
                    });
                }
                this.updateQueryModelField("voucherType", voucherTypeList);
                let countValList = getEnumList("ioFlag");
                let ioFlagList = [];
                ioFlagList.push({
                    value: null,
                    label: '- 全部 -'
                });
                if(countValList != null && countValList.length > 0) {
                    countValList.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        ioFlagList.push(queryItem);
                    });
                }
                this.updateQueryModelField("countVal", ioFlagList);
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'voucherType': function (row, colName, colValue, rowIndex, colConf) {
                        return self.getAccVoucherType(row.voucherType)
                    },
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                });
            },
            getAccVoucherType: function (voucherType) {
                if(!Utils.isNoB(voucherType) && voucherType != -1) {
                    return getEnumInfoWith("accVoucherType", "value", voucherType).text;
                } else {
                    return null;
                }
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                //
                this.getSpecificAccRecList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getSpecificAccRecList();
            },
            getSpecificAccRecList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.accId = self.accId;
                filterItems.vendorSn = self.vendorSn;
                filterItems.boundDevcId = self.boundDevcId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                accStockApi.getSpecificAccRecList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        let specificAccRecList = data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                        //
                        self.renderTable(specificAccRecList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/accStock/SpecificAccRecList.vue